/* https://react-popper-tooltip.netlify.app/ */

/* eslint-disable react/jsx-props-no-spreading */
import { useState } from "react";
import PropTypes from "prop-types";
import TooltipTrigger from "react-popper-tooltip";
import FadeTransition from "Shared/components/transitions/fade-transition";
import styles from "./tooltip.css";
import "react-popper-tooltip/dist/styles.css";

const getModifiers = () => [
    {
        name: "offset",
        options: {
            offset: [0, 6],
        },
    },
    {
        name: "preventOverflow",
        options: {
            padding: { left: 32, right: 32 },
        },
    },
];

const Tooltip = ({
    children,
    tooltip,
    trigger: tooltipTrigger,
    triggerClassName,
    placement: tooltipPlacement,
    usePortal = true,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggleOpen = (visible) => setIsOpen(visible);

    return (
        <TooltipTrigger
            trigger={tooltipTrigger}
            placement={tooltipPlacement}
            onVisibilityChange={handleToggleOpen}
            modifiers={getModifiers()}
            tooltip={({
                arrowRef,
                tooltipRef,
                getArrowProps,
                getTooltipProps,
                placement,
            }) => (
                <FadeTransition
                    isOpen={isOpen}
                    enterDuration={80}
                    exitDuration={0}
                >
                    <div
                        {...getTooltipProps({
                            ref: tooltipRef,
                            className: `tooltip-container ${styles.tooltipContainer}`,
                        })}
                    >
                        <div
                            {...getArrowProps({
                                ref: arrowRef,
                                className: `tooltip-arrow ${styles.tooltipArrow}`,
                                "data-placement": placement,
                            })}
                        />
                        {tooltip}
                    </div>
                </FadeTransition>
            )}
            usePortal={usePortal}
        >
            {({ getTriggerProps, triggerRef }) => (
                <span
                    {...getTriggerProps({
                        ref: triggerRef,
                        className: triggerClassName || "",
                    })}
                >
                    {children}
                </span>
            )}
        </TooltipTrigger>
    );
};

Tooltip.defaultProps = {
    trigger: ["hover", "click"],
    placement: "bottom",
};

Tooltip.propTypes = {
    children: PropTypes.node.isRequired,
    tooltip: PropTypes.node.isRequired,
    trigger: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
    triggerClassName: PropTypes.string,
    placement: PropTypes.string,
    usePortal: PropTypes.bool,
};

export default Tooltip;
